import vendorAtom from '@src/atom/vendor'
import useSigninQuery from '@src/hooks/queries/auth/signin/useSigninQuery'
import { useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { CenterModalContext } from '@src/contexts/popup/modal/CenterModalProvider'
import { getAnalytics, setUserId, setUserProperties } from 'firebase/analytics'

type ParamType = { redirectPath?: string | null }
const useSignin = ({ redirectPath }: ParamType) => {
	const usernameRef = useRef<HTMLInputElement | null>(null)
	const passwordRef = useRef<HTMLInputElement | null>(null)
	const { openCenterModal, closeCenterModal } = useContext(CenterModalContext)

	const [, setVendor] = useRecoilState(vendorAtom)
	const navigate = useNavigate()
	const { register, handleSubmit } = useForm({
		mode: 'onChange',
		defaultValues: {
			username: '',
			password: '',
		},
	})

	const { mutate } = useSigninQuery()

	const onSubmit = (data: { username: string; password: string }) => {
		if (data.username && data.password) {
			usernameRef?.current?.blur()
			passwordRef?.current?.blur()
			mutate(data, {
				onSuccess: (resData) => {
					const { vendor } = resData.data

					setVendor((vendorData) => ({
						...vendorData,
						isLoggedIn: true,
						username: vendor.username,
						no: vendor.no,
						role: vendor.role.role,
					}))

					const analytics = getAnalytics()
					setUserId(analytics, vendor.no)
					setUserProperties(analytics, {
						username: vendor.username,
					})

					if (redirectPath) {
						navigate(redirectPath)
					} else {
						navigate('/')
					}
				},
				onError: (resErr) => {
					const errorData = resErr.response?.data
					const error = errorData?.error
					const detailError = error?.detail_code
					if (detailError) {
						if (detailError === 'LOGIN_ERR_CHECK_EMAIL_PASSWORD') {
							openCenterModal({ desc: '아이디와 비밀번호를 확인해주세요' }, () => closeCenterModal)
						} else {
							openCenterModal({ desc: '예기치 못한 에러가 발생했어요' }, () => closeCenterModal)
						}
					} else {
						openCenterModal({ desc: '예기치 못한 에러가 발생했어요' }, () => closeCenterModal)
					}
				},
			})
		}
	}
	const getFormProps = ({ ...otherProps } = {}) => ({
		onSubmit: handleSubmit(onSubmit),
		...otherProps,
	})
	const getUsernameProps = ({ ...otherProps } = {}) => {
		return {
			register: register('username', {
				required: true,
			}),
			inputRef: usernameRef,
			...otherProps,
		}
	}
	const getPasswordProps = ({ ...otherProps } = {}) => {
		return {
			register: register('password', {
				required: true,
			}),
			inputRef: passwordRef,
			...otherProps,
		}
	}
	const getButtonProps = ({ ...otherProps } = {}) => ({
		...otherProps,
	})
	return { getFormProps, getUsernameProps, getPasswordProps, getButtonProps }
}
export default useSignin
